
import React from 'react';
import { Card, CardContent, CardDescription, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatCurrency, formatDate } from '@/components/borrowings/debt/utils';
import { ALMContract } from './types';

interface ContractSchedulesProps {
  contract: ALMContract;
}

const ContractSchedules: React.FC<ContractSchedulesProps> = ({ contract }) => {
  return (
    <div className="space-y-4">
      <Card>
        <CardContent className="pt-6">
          <CardTitle className="text-base mb-2">Payment Schedule</CardTitle>
          <CardDescription>Principal and interest payment schedule</CardDescription>
          
          <div className="mt-4 max-h-[400px] overflow-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Date</TableHead>
                  <TableHead className="text-right">Principal</TableHead>
                  <TableHead className="text-right">Interest</TableHead>
                  <TableHead className="text-right">Total</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {contract.paymentSchedule?.map((payment, index) => (
                  <TableRow key={index}>
                    <TableCell>{formatDate(payment.date)}</TableCell>
                    <TableCell className="text-right">{formatCurrency(payment.principal)}</TableCell>
                    <TableCell className="text-right">{formatCurrency(payment.interest)}</TableCell>
                    <TableCell className="text-right">{formatCurrency(payment.principal + payment.interest)}</TableCell>
                  </TableRow>
                ))}
                {(!contract.paymentSchedule || contract.paymentSchedule.length === 0) && (
                  <TableRow>
                    <TableCell colSpan={4} className="text-center py-4 text-muted-foreground">
                      No payment schedule available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>

      {contract.interestType === "Floating" && contract.resetSchedule && (
        <Card>
          <CardContent className="pt-6">
            <CardTitle className="text-base mb-2">Interest Rate Reset Schedule</CardTitle>
            <CardDescription>Future interest rate reset dates</CardDescription>
            
            <div className="mt-4 max-h-[300px] overflow-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>Reset Date</TableHead>
                    <TableHead>Reference Rate</TableHead>
                    <TableHead className="text-right">Spread</TableHead>
                    <TableHead className="text-right">Projected Rate</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {contract.resetSchedule.map((reset, index) => (
                    <TableRow key={index}>
                      <TableCell>{formatDate(reset.date)}</TableCell>
                      <TableCell>{reset.referenceRate}</TableCell>
                      <TableCell className="text-right">{reset.spread}%</TableCell>
                      <TableCell className="text-right">{(reset.projectedRate)}%</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default ContractSchedules;
